import { Box, Grid, Skeleton, Stack } from "@mui/material";

const StoreCategoriesSkeleton = () => {

    const windowWidth = window.innerWidth;
    return (
        <>

            <div style={{
                overflowY: "auto", height: "calc(100svh - 64px)", marginLeft: "20px",
                marginRight: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",


            }}>
                <div >
                    <Grid container style={{ paddingTop: "20px", flexWrap: "nowrap", overflowX: "auto", gap: "5px" }}>
                        {[...Array(4)].map((_, index) => (
                            <Grid key={index} container item xs={3} justifyContent={"center"} style={{ minWidth: "70px" }} >
                                <Skeleton variant="circular" width={70} height={70} />


                            </Grid>
                        ))}
                    </Grid>
                    <Box
                        display="flex" gap={2} flexWrap="wrap"
                        sx={{
                            margin: "auto", marginTop: "30px",
                            //  paddingInline: { xs: "20px", sm: "20px", md: "0px", lg: "0px", xl: "0px" }
                            flex: 1,
                            paddingInline: "5px !important",
                            justifyContent: { xs: "center", sm: "flex-start", md: "flex-start" },
                            border: '1.5px solid #D7DBEC',
                            paddingTop: "15px",
                            paddingBottom: "15px",

                            backgroundColor: "#fff",
                            overflowY: "auto",
                            maxHeight: "400px",
                            borderRadius: "5px",
                            gap: "10px !important",
                        }}

                    >
                        {[...Array(4)].map((_, index) => (
                            <Grid
                                key={index}
                                className={'borderColorPrimaryColorLight-300'}
                                style={{
                                    border: '1.5px solid ',
                                    // height: '150px',
                                    // margin: 'auto',
                                    borderRadius: '5px',
                                    background: '#fff',
                                    alignContent: 'center',
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
                                    aspectRatio: "1",
                                    width: "100%",
                                    height: "100%",

                                    maxHeight: windowWidth <= 500 ? "50%" : "150px",
                                    maxWidth: windowWidth <= 500 ? "50%" : "150px",
                                    display: "inline-block",
                                }}
                                sx={{ flex: '1 1 calc(50% - 10px)' }}

                                spacing={1}
                            >
                                <Grid container gap={"5px"} width={"100%"} height={"100%"} flexDirection={"column"} xs={12} justifyContent={"center"} alignItems={"center"} flexWrap={'nowrap'} >

                                    <Skeleton variant="rectangular" width={"100%"} height={"100%"} sx={{ transform: "unset", borderRadius: "5px" }} />
                                </Grid>
                            </Grid >
                        ))}

                    </Box>
                </div>
                <Grid item xs={12} sx={{ paddingBottom: "20px !important", paddingTop: "10px" }} >
                    <Skeleton variant="rectangular" width={"100%"} height={"60px"} sx={{ transform: "unset", borderRadius: "5px", marginBottom: "10px" }} />
                    <Skeleton variant="rectangular" width={"100%"} height={"176px"} sx={{ transform: "unset", borderRadius: "5px" }} />
                </Grid>

                {/* <GoftinoWidget isAuthorized={false} openChat={null} /> */}
            </div>




        </>
    )
}

export default StoreCategoriesSkeleton;